"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-2 (https://d1ane3fvebulky.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-3 (https://d2zq80gdmjim8k.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-south-1 (https://d2senuesg1djtx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-1 (https://doigdx0kgq9el.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ca-central-1 (https://d2s8ygphhesbe7.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-central-1 (https://d1mta8qj7i28i2.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-2 (https://d1742qcu2c1ncx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-3 (https://d2d0mfegowb3wk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * sa-east-1 (https://d3c9jyj3w509b0.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-2 (https://dnwj8swjjbsbt.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-1 (https://d68hl49wbnanq.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class CustomRequestHandling {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CustomRequestHandling = CustomRequestHandling;
class ManagedRuleGroupStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ManagedRuleGroupStatement = ManagedRuleGroupStatement;
class TextTransformation {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TextTransformation = TextTransformation;
class AllowAction {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AllowAction = AllowAction;
class DefaultAction {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DefaultAction = DefaultAction;
class XssMatchStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.XssMatchStatement = XssMatchStatement;
class ByteMatchStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ByteMatchStatement = ByteMatchStatement;
class ForwardedIPConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ForwardedIPConfiguration = ForwardedIPConfiguration;
class OrStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OrStatement = OrStatement;
class Label {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Label = Label;
class CustomHTTPHeader {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CustomHTTPHeader = CustomHTTPHeader;
class RegexPatternSetReferenceStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RegexPatternSetReferenceStatement = RegexPatternSetReferenceStatement;
class IPSetForwardedIPConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.IPSetForwardedIPConfiguration = IPSetForwardedIPConfiguration;
class CustomResponseBody {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CustomResponseBody = CustomResponseBody;
class Statement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Statement = Statement;
class BlockAction {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.BlockAction = BlockAction;
class RuleGroupReferenceStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RuleGroupReferenceStatement = RuleGroupReferenceStatement;
class LabelMatchStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.LabelMatchStatement = LabelMatchStatement;
class JsonMatchPattern {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.JsonMatchPattern = JsonMatchPattern;
class AndStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AndStatement = AndStatement;
class CountAction {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CountAction = CountAction;
class SizeConstraintStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SizeConstraintStatement = SizeConstraintStatement;
class FieldToMatch {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FieldToMatch = FieldToMatch;
class SqliMatchStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SqliMatchStatement = SqliMatchStatement;
class GeoMatchStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.GeoMatchStatement = GeoMatchStatement;
class RuleAction {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RuleAction = RuleAction;
class JsonBody {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.JsonBody = JsonBody;
class NotStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.NotStatement = NotStatement;
class OverrideAction {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OverrideAction = OverrideAction;
class Rule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Rule = Rule;
class CustomResponse {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CustomResponse = CustomResponse;
class RateBasedStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RateBasedStatement = RateBasedStatement;
class ExcludedRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ExcludedRule = ExcludedRule;
class VisibilityConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VisibilityConfig = VisibilityConfig;
class IPSetReferenceStatement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.IPSetReferenceStatement = IPSetReferenceStatement;
class WebACL extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::WAFv2::WebACL', properties);
    }
}
exports.default = WebACL;
WebACL.CustomRequestHandling = CustomRequestHandling;
WebACL.ManagedRuleGroupStatement = ManagedRuleGroupStatement;
WebACL.TextTransformation = TextTransformation;
WebACL.AllowAction = AllowAction;
WebACL.DefaultAction = DefaultAction;
WebACL.XssMatchStatement = XssMatchStatement;
WebACL.ByteMatchStatement = ByteMatchStatement;
WebACL.ForwardedIPConfiguration = ForwardedIPConfiguration;
WebACL.OrStatement = OrStatement;
WebACL.Label = Label;
WebACL.CustomHTTPHeader = CustomHTTPHeader;
WebACL.RegexPatternSetReferenceStatement = RegexPatternSetReferenceStatement;
WebACL.IPSetForwardedIPConfiguration = IPSetForwardedIPConfiguration;
WebACL.CustomResponseBody = CustomResponseBody;
WebACL.Statement = Statement;
WebACL.BlockAction = BlockAction;
WebACL.RuleGroupReferenceStatement = RuleGroupReferenceStatement;
WebACL.LabelMatchStatement = LabelMatchStatement;
WebACL.JsonMatchPattern = JsonMatchPattern;
WebACL.AndStatement = AndStatement;
WebACL.CountAction = CountAction;
WebACL.SizeConstraintStatement = SizeConstraintStatement;
WebACL.FieldToMatch = FieldToMatch;
WebACL.SqliMatchStatement = SqliMatchStatement;
WebACL.GeoMatchStatement = GeoMatchStatement;
WebACL.RuleAction = RuleAction;
WebACL.JsonBody = JsonBody;
WebACL.NotStatement = NotStatement;
WebACL.OverrideAction = OverrideAction;
WebACL.Rule = Rule;
WebACL.CustomResponse = CustomResponse;
WebACL.RateBasedStatement = RateBasedStatement;
WebACL.ExcludedRule = ExcludedRule;
WebACL.VisibilityConfig = VisibilityConfig;
WebACL.IPSetReferenceStatement = IPSetReferenceStatement;
